import { render, staticRenderFns } from "./DiscountsCreate.vue?vue&type=template&id=0843c2e4"
import script from "./DiscountsCreate.vue?vue&type=script&lang=js"
export * from "./DiscountsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports